import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Button, LinkButton } from './ui/Button';
import { useConsult } from '../contexts/ConsultContext';
export function StickyCta() {
  const {
    openConsult,
    isOpen
  } = useConsult();
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-207" data-mp="3gk5sxsy8mkpg">
      {visible && !isOpen && <motion.div initial={reduce ? false : {
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-ash-200 bg-white/95 px-5 py-3 backdrop-blur lg:hidden" data-id="element-208" data-mp="3kmsni1mamjqc">
          <div className="flex items-center gap-3" data-id="element-209" data-mp="76f8uqk4z7m7">
            <LinkButton href="#guide" variant="outline" className="flex-1" data-id="element-210" data-mp="272oqdkngenb">
              Free guide
            </LinkButton>
            <Button className="flex-1" onClick={() => openConsult('sticky')} data-id="element-211" data-mp="gwqovbh3h79g">
              Free consult
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}